// export const clearError = (form, type: String) => {
//     form.errors[type] = null;
// };

import { SelectOption } from '@/types';

export const optionsOnOff: SelectOption[] = [
    {
        value: 0,
        label: 'forms.off',
    },
    {
        value: 1,
        label: 'forms.on',
    },
];

export const optionsYesNo: SelectOption[] = [
    {
        value: 0,
        label: 'forms.no',
    },
    {
        value: 1,
        label: 'forms.yes',
    },
];

export const optionsCompanyServices: SelectOption[] = [
    {
        value: 'has_outsourcing',
        label: 'companies.form.has_outsourcing',
    },
    {
        value: 'has_consulting',
        label: 'companies.form.has_consulting',
    },
    {
        value: 'has_salary',
        label: 'companies.form.has_salary',
    },
    {
        value: 'has_robotics',
        label: 'companies.form.has_robotics',
    },
    {
        value: 'has_power_bi',
        label: 'companies.form.has_power_bi',
    },
];

export const optionsFrequency: SelectOption[] = [
    {
        value: 'six-monthly',
        label: 'companies.vat_frequency_options.six-monthly',
    },
    {
        value: 'monthly',
        label: 'companies.vat_frequency_options.monthly',
    },
    {
        value: 'quarterly',
        label: 'companies.vat_frequency_options.quarterly',
    },
    {
        value: 'n/a',
        label: 'companies.vat_frequency_options.n/a',
    },
];

export const optionsWeekdays: SelectOption[] = [
    {
        value: 'monday',
        label: 'forms.days_in_week.monday',
    },
    {
        value: 'tuesday',
        label: 'forms.days_in_week.tuesday',
    },
    {
        value: 'wednesday',
        label: 'forms.days_in_week.wednesday',
    },
    {
        value: 'thursday',
        label: 'forms.days_in_week.thursday',
    },
    {
        value: 'friday',
        label: 'forms.days_in_week.friday',
    },
];

export const optionsDays: SelectOption[] = [
    ...optionsWeekdays,
    {
        value: 'saturday',
        label: 'forms.days_in_week.saturday',
    },
    {
        value: 'sunday',
        label: 'forms.days_in_week.sunday',
    },
];
